module.exports = __webpack_public_path__ + "img/thumbnail_GrizzlyBear_m_normal.b08ae9ea.png";